import type { ComponentPropsWithoutRef } from 'react'
import { cx } from '@/lib/cx'

export type NoticeVariant = 'default' | 'policy'

type NoticeProps = ComponentPropsWithoutRef<'div'> & {
  // D-3: 'policy' is the prototype's gold-accented policy callout (left
  // accent stripe) — reserved for actual policy/legal copy (the AI-use
  // notices on the dashboard and Statements section). Other Notice callers
  // (e.g. admin/settings.tsx's fee-charging-deferred note) are plain
  // informational asides and keep the default neutral treatment.
  variant?: NoticeVariant
}

// A small parchment-soft callout box for policy/disclaimer copy. Extracted
// from the Statements AI-policy notice (T4 U6) so other surfaces — e.g. the
// dashboard AI-policy disclaimer (U11, R-X-1) — can reuse the same box
// instead of re-inlining the markup.
export function Notice({ className, variant = 'default', children, ...props }: NoticeProps) {
  return (
    <div
      className={cx(
        'rounded-md border bg-parchment-soft p-4 text-small text-ink-muted',
        variant === 'policy' ? 'notice--policy' : 'border-line',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  )
}
